import _ from 'lodash'

export const isValidConstant = (val: any): boolean => {
    // eslint-disable-next-line lodash/prefer-lodash-typecheck
    if (_.isFunction(val) || typeof val === 'symbol') return false

    if (_.isArray(val)) {
        return val.every(isValidConstant)
    }

    if (_.isPlainObject(val)) {
        return Object.values(val).every(isValidConstant)
    }

    return _.isBoolean(val) || _.isNumber(val) || _.isString(val)
}
